module.exports = __webpack_public_path__ + "img/imagen2.53671fb1.png";